import Button from '../../shared/buttons/button';

export type MobilePropsType = {
  mobile: string;
  onUpdateMobile: () => void;
  className?: string;
};

function MobileView({ mobile, onUpdateMobile, className }: MobilePropsType) {
  return (
    <div data-testid='smskey-mobile-view' className={className}>
      <p className='my-6 mt-8'>
        <span>شماره تلفن همراه: </span>
        <span>{mobile}</span>
      </p>
      <Button
        outline
        content='تغییر شماره تلفن همراه'
        onClick={onUpdateMobile}
        className='mx-auto my-4'
      />
    </div>
  );
}

export default MobileView;
